import { api, qs } from './client.js';
import type { ReportData } from './reports.js';

export interface BankCode {
  code: string;
  bankname: string;
  imageurl: string;
}

export interface BankListFilters {
  page?: number;
  perPage?: number;
  sort?: string;
  dir?: string;
  q?: string;
  corp?: string;
  state?: string;
  regFrom?: string;
  regTo?: string;
}

export interface BankStatusField {
  field: 'tax_date' | 'report_date' | 'succ_date';
  date: string;
  name?: string;
}

export interface BankEditBody {
  bankcode: string;
  banksn?: string;
  bankinname?: string;
  bankmemo?: string;
  amount: string | number;
  no_tax?: number;
  up_name: string;
  tax_name?: string;
  tax_date?: string;
  re_name?: string;
  report_date?: string;
  succ_date?: string;
  memo?: string;
}

export interface BankCreateBody extends BankEditBody {
  corp: string;
}

export interface IncomeCheckMatch {
  amount: number;
  sender: string;
  reportDate: string;
}

export interface IncomeCheckResult {
  no: string;
  date: string;
  sender: string;
  outAmount: number | null;
  matches: IncomeCheckMatch[];
}

export interface ExcelPendingRow {
  banksn: string;
  amount: number;
}

/**
 * 목록 조회는 그대로 정의 기반 화면(report.registry.ts 의 payment-bank)을 쓴다.
 * 여기서는 원본이 iframe 모달로 처리하던 쓰기 동작만 감싼다.
 */
export const paymentBankApi = {
  list: (filters: BankListFilters) => api.get<ReportData>(`/reports/payment-bank${qs({ ...filters })}`),

  codes: () => api.get<BankCode[]>('/payment/bank/codes'),

  setStatus: (seq: number, body: BankStatusField) =>
    api.patch<{ success: boolean }>(`/payment/bank/${seq}/status`, body),

  update: (seq: number, body: BankEditBody) => api.patch(`/payment/bank/${seq}`, body),

  create: (body: BankCreateBody) => api.post<{ seq: string }>('/payment/bank', body),

  remove: (seq: number) => api.del(`/payment/bank/${seq}`),

  transferFileUrl: (seqs: number[]) => `/api/payment/bank/transfer-file${qs({ seqs: seqs.join(',') })}`,

  incomeCheck: (text: string) =>
    api.post<{ results: IncomeCheckResult[] }>('/payment/bank/income-check', { text }),

  excelPending: (corp: string) => api.get<ExcelPendingRow[]>(`/payment/bank/excel-check/pending${qs({ corp })}`),

  excelApply: (items: { banksn: string; amount: string | number }[]) =>
    api.post<{ success: boolean; count: number }>('/payment/bank/excel-check/apply', { items }),
};
